import { useState, useEffect } from "react";

// CSS
import './index.css'

// Styling Assets
import { ThemeProvider } from "styled-components";
import GlobalStyle from "./GlobalStyle.jsx";

// Routing
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Partials
import Header from "./components/partials/Header";
import Footer from "./components/partials/Footer";

// Cookie
import Cookies from "js-cookie";

// Pages
import Home from "./pages/Home";
import Servers from "./pages/Servers";
import SpecificServer from "./pages/SpecificServer";
import MyServers from "./pages/MyServers";
import SignIn from "./authPages/SignIn";
import AddServer from "./pages/AddServer.jsx";
import Featured from "./pages/Featured.jsx";

function App() {

  const [token, setToken] = useState(Cookies.get('msl_ui_tok_id') || '')
  const [isAuthourized, setIsAuthourized] = useState(false);
  const [user, setUser] = useState({
    email: '',
    username: ''
  })


  const GetUserInfo = async (token) => {
    try {
      await fetch(`https://tumq-backend.vercel.app/auth/user`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        },
      }).then((response) => {
        return response.json();
      }).then((data) => {

        if (!data.success) {
          setIsAuthourized(false);
        }

        if (token && data.success) {
          Cookies.set('msl-uid-dta', JSON.stringify(data.user));
          setUser({
            email: data.user.email,
            username: data.user.username
          })
          setIsAuthourized(true);
        }
      })
    } catch (error) {
      console.log('Auth Error', error)
    }
  }

  useEffect(() => {
    if (token !== '') {
      GetUserInfo(token)
    } else {
      setIsAuthourized(false)
    }
  }, [token])

  // Theme
  const theme = {
    colors: {
      heading: "rgb(24 24 29)",
      text: "rgba(29 ,29, 29, .8)",
      white: "#fff",
      black: " #212529",
      helper: "#8490ff",

      bg: "#F6F8FA",
      footer_bg: "#0a1435",
      btn: "rgb(98 84 243)",
      border: "rgba(98, 84, 243, 0.5)",
      hr: "#ffffff",
      gradient:
        "linear-gradient(0deg, rgb(132 144 255) 0%, rgb(98 189 252) 100%)",
      shadow:
        "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
      shadowSupport: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
    },
    media: {
      mobile: "768px",
      tab: "998px",
    },
  };

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <Header username={user.username} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth/signIn" element={ !isAuthourized ? <SignIn /> : <Home />} />
          <Route path="/servers" element={<Servers />} />
          <Route path="/servers/my-servers" element={ !isAuthourized ? <SignIn /> : <MyServers username={user.username} />} />
          <Route path="/servers/add-server" element={ !isAuthourized ? <SignIn /> : <AddServer username={user.username} />} />
          <Route path="/get-featured" element={!isAuthourized ? <SignIn /> : <Featured />} />
          <Route path="/server" element={<SpecificServer isAuthourized={isAuthourized} email={user.email} />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
